<script setup lang="ts">
const { as = 'div' } = defineProps<{
  as?: string;
  noAlignment?: boolean;
  noPadding?: boolean;
}>();
defineSlots<{ default: () => void }>();
</script>

<template>
  <component
    :is="as"
    :class="{
      'px-r4 sm:px-r12 lg:px-r18': !noPadding,
      'mx-auto w-full max-w-480': !noAlignment,
    }"
  >
    <slot />
  </component>
</template>
